import Const from '../util/Constants';
import DateUtil from '../util/Util';

class ContactController {

  static addModel = model => {
    let contact ={};
    const keys = Object.keys(model);
    for(let i = 0; i < keys.length; i++) {
      if(!model[keys[i]].editable) continue;
      //TODO: special fields
      switch(model[keys[i]].field_type) {
        case Const.Date:
        case Const.DateTime:
          contact[keys[i]] = '';
          if(model[keys[i]].default_value === 'today') {
            contact[keys[i]] = DateUtil.dateToServerDateTime(new Date());
          }
          break;

        case Const.MultiSelect:
          contact[keys[i]] = '';
          if(model[keys[i]].default_value && model[keys[i]].default_value !== '') {
            contact[keys[i]] = '~' + model[keys[i]].default_value.replace(',', '~') + '~';
          }
          break;

        case Const.Address:
          contact[keys[i]] = [];
          break;
        
        default:
          contact[keys[i]] = model[keys[i]].default_value;
      }
    }
    contact.status = Const.Active;
    return contact;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'id' && keys[i] !== 'status'
        && keys[i] !== 'firstname' && keys[i] !== 'middlename' && keys[i] !== 'lastname'
        && keys[i] !== 'gender' && keys[i] !== 'dob' && keys[i] !== 'progress'
        && keys[i] !== 'company_name' && keys[i] !== 'anniversary' && keys[i] !== 'industry'
        && keys[i] !== 'responsible_person' && keys[i] !== 'source' && keys[i] !== 'interested_product'
        && keys[i] !== 'enquiry_date' && keys[i] !== 'email_opt' && keys[i] !== 'sms_opt'
        && keys[i] !== 'phone' && keys[i] !== 'email' && keys[i] !== 'site'
        && keys[i] !== 'address'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && fields[keys[i]].status !== Const.Trash) {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default ContactController;